import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'doctor-checkup-reminder-banner',
  templateUrl: './doctor-checkup-reminder-banner.html',
  standalone: true,
  imports: [NgClass],
})
export class DoctorCheckupReminderBannerComponent {
  @Input() doctorDetails: { image: string; firstName: string, specialization: string } = {
    image: 'https://storage.googleapis.com/heallo-other-user-files/doctor_api_charu_07302024_1722317224002.jpg',
    firstName: 'Dr. Charu',
    specialization: 'Dermatologist'
  };
  @Input() cssClasses: string = '';
  @Output() actionClick = new EventEmitter<void>();

  handleClick(): void {
    this.actionClick.emit();
  }
} 